var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _rect8, _path3, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlumbing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18,20.4h-0.9c-0.2,0-0.4,0.3-0.4,0.5V24c0,0.2,0.2,0.4,0.4,0.4H18c-0.2,2.9-2.6,5.1-5.5,5.1h-0.2v-1.1 c0-0.2-0.2-0.4-0.4-0.4H8.6c-0.2,0-0.4,0.2-0.4,0.4v1.1H5.7c-0.2,0-0.4,0.2-0.4,0.4v7.6c0,0.2,0.2,0.5,0.4,0.5h2.6v1 c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0h3.2c0.2,0,0.4-0.2,0.4-0.4l0,0v-1h0.8c7.6,0,13.7-6,13.9-13.6h0.9c0.2,0,0.4-0.2,0.4-0.4v-3.1 c0-0.2-0.2-0.5-0.4-0.5h-0.8c0.3-2.8,2.6-5,5.5-5h0.2v1c0,0.2,0.2,0.5,0.4,0.5h3.2c0.2,0,0.4-0.3,0.4-0.5v-1h2.6 c0.2,0,0.4-0.2,0.4-0.4v0V7.3c0-0.2-0.2-0.4-0.4-0.4l0,0h-2.6v-1c0-0.2-0.2-0.4-0.4-0.4h-3.2c-0.2,0-0.4,0.2-0.4,0.4v1H32 C24.4,6.9,18.3,12.9,18,20.4z M17.5,23.6v-2.3h1.9v2.3H17.5z M9.1,28.9h2.3v1.8H9.1V28.9z M9.1,34.2h2.3V36H9.1V34.2z M9.1,33.3 v-1.8h2.3v1.8H9.1z M11.4,38.5H9.1v-1.7h2.3V38.5z M13,37.2h-0.8v-6.7h0.2c3.4,0,6.1-2.6,6.4-6h7.3C25.9,31.5,20.1,37.2,13,37.2z  M20.2,23.6v-2.3H22v2.3H20.2z M23,23.6v-2.3h1.7v2.3H23z M27.4,21.3v2.3h-1.8v-2.3H27.4z M35.8,16h-2.3v-1.8h2.3V16z M35.8,10.7 h-2.3V8.9h2.3V10.7z M35.8,11.6v1.7h-2.3v-1.7H35.8z M33.5,6.3h2.3v1.8h-2.3V6.3z M32,7.8h0.8v6.7h-0.2c-3.3,0-6.1,2.6-6.4,5.9h-7.3 C19.1,13.4,24.9,7.8,32,7.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 21.3,
    fill: "#E3E3E3",
    width: 1.8,
    height: 2.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 21.3,
    fill: "#E3E3E3",
    width: 1.8,
    height: 2.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 21.3,
    fill: "#E3E3E3",
    width: 1.8,
    height: 2.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 14.2,
    fill: "#E3E3E3",
    width: 2.3,
    height: 1.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 8.9,
    fill: "#E3E3E3",
    width: 2.3,
    height: 1.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 11.6,
    fill: "#E3E3E3",
    width: 2.3,
    height: 1.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 6.3,
    fill: "#E3E3E3",
    width: 2.3,
    height: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M18.9,20.4h7.3c0.3-3.3,3.1-5.9,6.4-5.9h0.2V7.8H32C24.9,7.8,19.1,13.4,18.9,20.4z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 21.3,
    fill: "#E3E3E3",
    width: 1.8,
    height: 2.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M18.9,24.4c-0.3,3.4-3,6-6.4,6h-0.2v6.7h0.8c7.1,0,12.9-5.6,13.1-12.7H18.9z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 34.2,
    fill: "#E3E3E3",
    width: 2.3,
    height: 1.8
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 31.5,
    fill: "#E3E3E3",
    width: 2.3,
    height: 1.8
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 28.9,
    fill: "#E3E3E3",
    width: 2.3,
    height: 1.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 36.8,
    fill: "#E3E3E3",
    width: 2.3,
    height: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbing);
export default __webpack_public_path__ + "static/media/plumbing.af30bef98fc8c8c2f0431d83f78b6e6e.svg";
export { ForwardRef as ReactComponent };